/**
 * A single random value fixed for the lifetime of this app launch.
 *
 * Evaluated once when the bundle first loads, so every reader sees the same
 * number until the app is relaunched (a fresh JS context re-evaluates it). It
 * exists so "shuffle, but stay stable this session" surfaces — the profile
 * Trades-to-chase strip (see eventRadar.pickRandomTrades) — can re-randomise on
 * each launch without reshuffling on every React re-render.
 *
 * Isolated in its own module (rather than a `Math.random()` at the top of
 * eventRadar) so eventRadar stays pure and unit-testable: the seed is passed in.
 */
export const LAUNCH_SEED = Math.floor(Math.random() * 0x7fffffff);
